import GenericException from 'src/exceptions/GenericException';

/**
 * Exception thrown when there's a generic failure of the auth token,
 * usually in the axios refresh token interceptor.
 */
class AuthTokenFailureException extends GenericException {}

export default AuthTokenFailureException;
